<template>

  <div>

    <div class="card card-info" v-if="state == 'edit'" >
      <div class="card-header">
        <h3 class="card-title">Create</h3>
      </div>
      <form v-on:submit="save">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Session *</label>
                <select class="form-control " v-model="Criteria.ActiveSemesterID" required>
                  <option value=''>---Select Semester---</option>
                  <option v-for="item in Semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Degree *</label>
                <select class="form-control " v-model="Criteria.DegreeID" required>
                  <option value=''>---Select Degree---</option>
                  <option v-for="item in Degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>Choices *</label>
                <select class="form-control " v-model="Criteria.Choices" required>
                  <option value="">---Select Choice---</option>
                  <option value="1" >1</option>
                  <option value="2" >2</option>
                  <option value="3" >3</option>
                  <option value="4" >4</option>
                  <option value="5" >5</option>
                  <option value="6" >6</option>
                  <option value="7" >7</option>
                  <option value="8" >8</option>
                  <option value="9" >9</option>
                  <option value="10" >10</option>
                  <option value="11" >11</option>
                  <option value="12" >12</option>
                  <option value="13" >13</option>
                  <option value="14" >14</option>
                  <option value="15" >15</option>
                  <option value="16" >16</option>
                  <option value="17" >17</option>
                  <option value="18" >18</option>
                  <option value="19" >19</option>
                  <option value="20" >20</option>
                  <option value="21" >21</option>
                  <option value="22" >22</option>
                  <option value="23" >23</option>
                  <option value="24" >24</option>
                  <option value="25" >25</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Min Age *</label>
                <input type="text" class="form-control" style="text-align:right" v-model="Criteria.Min" required v-mask="'##'" />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Max Age *</label>
                <input type="text" class="form-control" style="text-align:right" v-model="Criteria.Max" required v-mask="'##'" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Qualification</label>
              <div class=" table-responsive">
                <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-info text-white">
                    <tr>
                      <td width="30%">Name</td>
                      <td width="40%">Type</td>
                      <td>Required</td>
                      <td>Optional</td>
                      <td>Awating result</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in AggregateType">
                      <td>{{item.Name}}</td>
                      <td>{{item.Description}}</td>
                      <td align="center">
                        <input class="form-check" type="checkbox" v-model="item.Required" >
                      </td>
                      <td align="center">
                        <input class="form-check" type="checkbox" v-model="item.Optional">
                      </td>
                      <td align="center">
                        <input class="form-check" type="checkbox" v-model="item.ResultAwaiting" >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
        </div>

        <div class="card-footer">
          <button type="button" class="btn btn-primary" v-on:click="Back()">Back to List</button>
          <input type="submit" value="Save" class="btn btn-success float-right" />
        </div>
      </form>
    </div>

    <div class="card card-info" v-else >
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          Eligibility Criteria Records <button v-on:click="state = 'edit';" type="button" class=" float-right btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table id="table" class="table table-bordered table-sm text-sm" width="100%">
                <thead class="bg-info">
                  <tr>
                    <td>Session</td>
                    <td>Degree</td>
                    <td>Choices</td>
                    <td>Minimum Age</td>
                    <td>Maximum Age</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in eligibilityCriteriaRecords">
                    <td>{{item.Semester}}</td>
                    <td>{{item.Name}}</td>
                    <td align="right">{{item.Choices}}</td>
                    <td align="right">{{item.Min}}</td>
                    <td align="right">{{item.Max}}</td>
                    <td align="center" hidden><button style="width: 70px;" v-on:click="edit(item.DegreeID, item.ActiveSemesterID)" class="btn btn-primary btn-sm">Edit</button></td>
                    <td  align="center"> <i class="fa fa-2x fa-edit" v-on:click="edit(item.DegreeID, item.ActiveSemesterID)"></i></td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  const axios = require('axios').default;

  export default ({

    data() {
      return {
        Criteria: { ActiveSemesterID: '', DegreeID: '', Choices: '', Min: "18", Max: "50", Required: '', Optional: '', ResultAwaiting: '' },
        Semesters: [],
        Degrees: [],
        AggregateType: [],
        eligibilityCriteriaRecords: [],
        state: 'record',
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {
      //stateChange() {
      //  this.state = 'edit';

      //},

      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/pageLoadEligibiltyCriteria")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.Semesters = res.data.semester;
              vm.Degrees = res.data.degree;
              vm.AggregateType = res.data.aggregate;
              vm.eligibilityCriteriaRecords = res.data.record;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },

      Back() {
        //this.state = 'record';
        location.reload();
      },

      edit(degID, semID) {
        var vm = this;

        axios.post("/api/AdmissionApi/EditEligibiltyCriteria?ID=" + degID + '&semID=' + semID)
          .then(function (res) {
            if (res.data.status) {
              vm.state = 'edit';
              var lst = res.data.editCriteria;
              vm.Criteria = lst[0];
              for (var i = 0; i < vm.AggregateType.length; i++) {
                for (var j = 0; j < lst.length; j++) {
                  if (vm.AggregateType[i].AggregateTypeID == lst[j].AggregateTypeID) {
                    vm.AggregateType[i].Required = lst[j].Required;
                    vm.AggregateType[i].Optional = lst[j].Optional;
                    vm.AggregateType[i].ResultAwaiting = lst[j].ResultAwaiting;
                  }
                }
              }
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },

      save(e) {
         
          e.preventDefault();
          var vm = this;
          startReq();
          axios.post('/api/AdmissionApi/saveEligibilityCriteria', {
            Criteria: vm.Criteria,
            lst: vm.AggregateType,
          })
            .then(function (res) {
              endReq();
              if (res.data.status) {
                toastr.success("Saved Successfully", "Done");
                vm.clear();
              }
              else
                toastr.error(res.data.msg);

            })
            .catch(function (err) {
              endReq();
              if (err.response) {
                var res = err.response;
                if (res.status == 401) {
                  toastr.error(res.data);
                }
                else {
                  for (const [key, value] of Object.entries(res.data.errors)) {
                    //console.log(`${value}`);
                    toastr.error(`${value}`);
                  }
                }
              }
            })
       
    
      },

      clear() {
        this.Criteria = { SemesterID: '', DegreeID: '', Choices: '', Min: "18", Max: "50", Required: '', Optional: '', ResultAwaiting: '' };
        this.AggregateType = [];
      },

    }
  });

  
</script> 

<style>

</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/eligibilityCriteria.vue